// src/api/hraAnalyticsApi.js
import apiClient from "./apiClient";

function filenameFromContentDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/i.exec(disposition);
  if (!match) return fallback;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

const hraAnalyticsApi = {
  // 📊 Obtener analítica HRA por empresa con filtros opcionales
  getHraAnalyticsByCompany: async (companyId, filters = {}) => {
    try {
      const response = await apiClient.get(`/analytics/hra/${companyId}`, {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analítica HRA por empresa:", error);
      throw error;
    }
  },

  // 📊 Obtener analítica HRA global con filtros opcionales
  getHraGlobalAnalytics: async (filters = {}) => {
    try {
      const response = await apiClient.get(`/analytics/global/hra`, {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analítica HRA global:", error);
      throw error;
    }
  },

  // 👥 Obtener lista de respondants HRA por empresa (JSON)
  getHraRespondantsByCompanyId: async (companyId) => {
    try {
      const response = await apiClient.get(
        `/analytics/hra/${companyId}/hra-respondants`
      );
      return response.data.respondants;
    } catch (error) {
      console.error("Error obteniendo respondants HRA por empresa:", error);
      throw error;
    }
  },

  // ⬇️ Exportar respondants HRA (Excel) — devuelve { blob, filename }
  getHraRespondantsByCompanyIdExport: async (companyId) => {
    try {
      const response = await apiClient.get(
        `/analytics/hra/${companyId}/hra-respondants/export`,
        {
          responseType: "blob",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        }
      );

      const filename = filenameFromContentDisposition(
        response.headers["content-disposition"],
        `hra-respondants-${companyId}.xlsx`
      );

      // Quien llame decide si descarga o usa el Blob
      return { blob: response.data, filename };
    } catch (error) {
      console.error("Error exportando respondants HRA por empresa:", error);
      throw error;
    }
  },

  // 💾 Helper opcional para disparar la descarga en el navegador
  downloadHraRespondantsByCompanyIdExcel: async (companyId) => {
    const { blob, filename } =
      await hraAnalyticsApi.getHraRespondantsByCompanyIdExport(companyId);

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || `hra-respondants-${companyId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
};

export default hraAnalyticsApi;
